module.exports = __webpack_public_path__ + "static/img/hair_01.d033f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_01.png
// module id = FFgG
// module chunks = 0